import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email address')
    .required('Required'),
  first_name: Yup.string()
    .label('First name')
    .required('Required')
    .min(3),
  last_name: Yup.string()
    .label('Last name')
    .required('Required')
    .min(3),
  password: Yup.string()
    .when('id', (id, schema) =>
      id
        ? schema.test('twelve chars min', 'Password must be at least 12 characters', (value) => {
          if (value == null || value == '')
            return true
          else
            return value.length >= 12
        })
        : schema
            .required('Required')
            .min(12)
    ),
  password_confirmation: Yup.string()
    .when('id', (id, schema) =>
      id
        ? schema.when('password', (pwd, schema) => {
          return pwd == '' || pwd == null
            ? schema.oneOf([Yup.ref('password'), null], 'Passwords does not match')
            : schema
               .oneOf([Yup.ref('password'), null], 'Passwords does not match')
               .required('Required')
        })
        : schema
           .oneOf([Yup.ref('password'), null], 'Passwords does not match')
           .required('Required')
    ),
  location_ids: Yup.array().of(Yup.string()).min(1, 'Required'),
  role_ids: Yup.array().of(Yup.string()).min(1, 'Required')

})
